import React, { FC, useState } from 'react';

import { IEventGroup, IEventItem, IEventRound } from '../../../../store/player/events/store';

import Input from '../../../../components/Input';
import List from '../../../../components/Lists/List/List';

import { Group } from './Components/Group';

interface IProps {
  event: IEventItem;
  roundId: string;
}

const GroupLookup: FC<IProps> = props => {
  const { event, roundId } = props;

  const [searchValue, setSearchValue] = useState('');

  const search = (evnt: any): void => {
    setSearchValue(evnt.target.value);
  };

  const filter = (group: IEventGroup): boolean => {
    const result = searchValue
      ? group.enrollments.reduce(
          (accumulator, member) =>
            accumulator ||
            member.user.firstName.toUpperCase().includes(searchValue.toUpperCase()) ||
            member.user.lastName.toUpperCase().includes(searchValue.toUpperCase()),
          false
        )
      : true;

    return result;
  };

  const roundIndex =
    event && event.rounds && event.rounds.findIndex((r: IEventRound) => r.id === Number(roundId));
  const currentRound = event && event.rounds && event.rounds[roundIndex];
  const useFlights = event && event.useFlights;

  return (
    <div className="group-lookup wrapper">
      <div className="padding">
        <Input
          id="group-lookup"
          label="PLAYER LOOKUP"
          onChange={search}
          outlined={true}
          placeholder="PLAYER LOOKUP"
          type="search"
        />
      </div>

      <List
        items={currentRound.groups}
        context={{ currentRound, roundId, useFlights }}
        customFilter={filter}
        renderItem={Group}
      />
    </div>
  );
};

export default GroupLookup;
